import store from "../../store/store";
import Contact from "../../entities/contact";
import Resource from "../../entities/resource";
import Address from "../../entities/address";

function sort(a: Resource | Address, b: Resource | Address): number {
    if (!a) return 1;
    if (!b) return -1;
    const ap = a.isPrimary ? 0 : 1;
    const bp = b.isPrimary ? 0 : 1;

    return ap - bp;
}

/**
 * Get emails for a contact
 * @param {Contact} contact
 * @returns {Resource[]}
 */
export const getEmails = (contact: Contact): Resource[] => {
    if (!contact) return [];
    else return store.getState().resources
        .filter(r => r.type === 'email' && r.entityId === contact.id)
        .sort(sort);
};

/**
 * Get phone numbers for a contact
 * @param {Contact} contact
 * @returns {Resource[]}
 */
export const getPhones = (contact: Contact): Resource[] => {
    if (!contact) return [];
    else return store.getState().resources
        .getMappingFor('entityId', contact.id)
        .filter(r => r.type === 'phone').sort(sort);
};

/**
 * Get addresses for a contact
 * @param {Contact} contact
 * @returns {Address[]}
 */
export const getAddresses = (contact: Contact): Address[] => {
    if (!contact) return [];
    else return store.getState().addresses.getMappingFor('entityId', contact.id).sort(sort);
};

/**
 * Get resources for a contact.
 *
 * @param {Contact} contact
 * @returns {Resource[]}
 */
export const getResources = (contact: Contact): Resource[] => {
    return store.getState().resources.getMappingFor('entityId', contact.id);
};